import React, { Component } from 'react';

import Theme from 'Theme';
import Button from 'components/Button';
import PendingFile from './components/PendingFile';
import { MarginTop } from './components/Styled';

import { MessagePopIn } from 'components/ToolTip';

const INITIAL_STATE = {
  file: null,
  description: ''
};

export class FileUploader extends Component {
  constructor (props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.afterUpload = this.afterUpload.bind(this);
    this.onFileDelete = this.onFileDelete.bind(this);
    this.onFileSelected = this.onFileSelected.bind(this);

    this.state = INITIAL_STATE;
  }

  onFileDelete () {
    this.setState({ file: null });
  }

  onChange (name, value) {
    this.setState(() => ({ [name]: value }));
  }

  onSubmit () {
    let { file } = this.state;
    let { addDocument } = this.props;

    addDocument && addDocument(file);
  }

  afterUpload () {
    this.setState(() => INITIAL_STATE);
  }

  onFileSelected ({ target: { files = [] } }) {
    const file = files[0];

    // TODO handle error
    if (!file) return console.log(`[${this.constructor.name}] No file found`);

    this.setState(() => ({
      file: file
    }));
  }

  hasFile () {
    return !!this.state.file;
  }

  render () {
    let { file } = this.state;
    let { loading } = this.props;

    const FileButton = (
      <Button.Upload
        pendingFile={!!file}
        onChange={this.onFileSelected}
        loading={loading}
      />
    );

    const UploadButton = (
      <Button.Primary
        icon={'cloud_upload'}
        color={Theme.successColor}
        disabled={!file}
        label={'Upload File'}
        onClick={this.onSubmit}
      />
    );

    return (
      <React.Fragment>
        {file && <MarginTop margin={'16px'} />}

        <PendingFile
          file={file}
          description={this.props.description}
          onFileDelete={this.onFileDelete}
        />

        {!file
          ? FileButton
          : <MessagePopIn
            inline
            hide={!file}
            message={'Your document is ready to be uploaded. Click here to upload.'}
          >
            {UploadButton}
          </MessagePopIn>}

        <MarginTop margin={'8px'} />

        {file ? FileButton : UploadButton}
      </React.Fragment>
    );
  }
}

export default FileUploader;
